import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { switchAgencyOnAlert } from '../../Utils/AgencySwitch';
import { setGlobalLoading } from '../../Store/Actions';

// FCM notifications deep-link straight into existing pages (see SahiCRM_202505/App_Code/Set.cs:
// SendTaskAlert -> /Web/tasks?tid=<taskID>, SendThreadAlert -> /Web/threads?thrid=<threadID>) with
// no agency info in the URL. Tasks.jsx/Threads.jsx only search their already-loaded, agency-scoped
// Redux data for that id, so a link to an item in a different agency than the one currently active
// silently finds nothing. This component runs once per such URL and calls switchAgencyOnAlert to
// switch first - the per-page tid/thrid effects then pick the item up once the switched-in data loads.
const AgencyAlertGate = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const handledKeyRef = useRef(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        // Scoped by pathname because 'tid' means different things on different pages
        // (thread TYPE id on /threads, /kanban, /loss-analysis; task id only on /tasks).
        const taskID = location.pathname === '/tasks' ? params.get('tid') : null;
        const threadID = (location.pathname === '/threads' || location.pathname === '/threads-detail') ? params.get('thrid') : null;

        if (!taskID && !threadID) return;

        const dedupeKey = `${location.pathname}${location.search}`;
        if (handledKeyRef.current === dedupeKey) return;
        handledKeyRef.current = dedupeKey;

        (async () => {
            dispatch(setGlobalLoading(true));
            await switchAgencyOnAlert({ taskID, threadID }, dispatch);
            dispatch(setGlobalLoading(false));
        })();
    }, [location.pathname, location.search, dispatch]);

    return null;
};

export default AgencyAlertGate;
